import React from 'react';
import { Icon } from '@amzn/storm-ui';
import { userCircle } from '@amzn/storm-ui-icons';
import { ExpandableItemBtn, MobileSideNavItemText } from './styles';
import { useSidenavBundle } from 'src/providers/PantherLocalizationProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

interface UserPreferenceMenuItemProps {
  handleClick: () => void;
}

export const UserPreferenceMenuItem: React.VFC<UserPreferenceMenuItemProps> = ({
  handleClick,
}) => {
  const bundle = useSidenavBundle();

  return (
    <ExpandableItemBtn
      onClick={handleClick}
      aria-label={bundle.getMessage('sidenav-your-preferences-label')}
      data-ccx-e2e-id="aac-user-preferences"
      {...getTaktAttributes('aac-user-preferences', chromeComponents.NAV)}
    >
      <Icon type={userCircle} size="xlarge" />
      <MobileSideNavItemText>
        {bundle.getMessage('sidenav-your-preferences-label')}
      </MobileSideNavItemText>
    </ExpandableItemBtn>
  );
};
